import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoadingSpinnerService {
    private static readonly SHOW_DELAY = 400;

    private readonly _loading = signal(false);
    private showTimeoutId: ReturnType<typeof setTimeout> | null = null;

    get loading() {
        return this._loading;
    }

    show() {
        if (this._loading()) return;
        this.resetTimeout();
        this.showTimeoutId = setTimeout(() => {
            this._loading.set(true);
            this.showTimeoutId = null;
        }, LoadingSpinnerService.SHOW_DELAY);
    }

    hide() {
        this.resetTimeout();
        this._loading.set(false);
    }

    private resetTimeout() {
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
            this.showTimeoutId = null;
        }
    }
}
